import api from '../../../utils/api';
import setAuthToken from '../../../utils/setAuthToken';

export const authUser = (credentials) => async (dispatch) => {
  const { data } = await api.post('/auth', credentials);
  setAuthToken(data.token);

  dispatch({
        type: 'LOGIN_SUCCESS',
        payload: data
    })

  return data;
};
